export default __webpack_public_path__ + "static/media/estate.ce679d7c.svg";